<template>
  <v-card
    class="giveaways "
  >
    <v-card-title>
      Giveaways
    </v-card-title>
    <v-card-text>
      <v-skeleton-loader
        v-if="loading"
        type="table"
      />
      <v-data-table
        v-else
        :headers="headers"
        :items="giveaways"
        hide-default-footer
      />
    </v-card-text>
    <v-card-actions>
      <v-dialog
        v-model="loadUnredeemedGiveawaysDialog"
        max-width="600px"
        persistent
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
          >
            Load unredeemed
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            Load unredeemed giveaways
          </v-card-title>
          <v-card-subtitle>
            Giveaways which were added but not used in previous events
          </v-card-subtitle>
          <v-card-text>
            <v-form>
              <v-container>
                <v-row>
                  <v-col
                    cols="6"
                  >
                    <v-text-field
                      v-model="type"
                      label="Type"
                    />
                  </v-col>
                  <v-col
                    cols="6"
                  >
                    <v-text-field
                      v-model="subtype"
                      label="Subtype"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="closeUnredeemedGiveawaysDialog"
            >
              Cancel
            </v-btn>
            <v-spacer />
            <v-btn
              @click="loadUnredeemedGiveaways"
            >
              Load
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-spacer />

      <v-dialog
        v-model="addNewGiveawaysDialog"
        max-width="600px"
        persistent
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
          >
            Add giveaways
          </v-btn>
        </template>

        <v-card>
          <v-card-title>
            Add new giveaways
          </v-card-title>
          <v-card-text>
            <v-form>
              <v-container>
                <v-row>
                  <v-col
                    cols="6"
                  >
                    <v-text-field
                      v-model="type"
                      label="Type"
                    />
                  </v-col>
                  <v-col
                    cols="6"
                  >
                    <v-text-field
                      v-model="subtype"
                      label="Subtype"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-textarea
                      v-model="codes"
                      label="Codes"
                      hint="One per line"
                      outlined
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="closeAddGiveawaysDialog"
            >
              Cancel
            </v-btn>
            <v-spacer />
            <v-btn
              @click="addNewGiveaways"
            >
              Add new giveaways
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-actions>
  </v-card>
</template>

<script>
import GiveawaysClient from '@/api/GiveawaysClient';
import { mapGetters } from 'vuex';

export default {
  name: 'GiveawayStats',
  props: {
    currentUser: {
      type: Object,
      default: () => {},
    },
    eventId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      giveaways: [],
      addNewGiveawaysDialog: false,
      loadUnredeemedGiveawaysDialog: false,
      type: '',
      subtype: '',
      codes: '',
    };
  },
  computed: {
    ...mapGetters({
      currentJwtToken: 'currentJwtToken',
    }),
    headers() {
      return [
        { text: 'Type', value: 'type' },
        { text: 'Subtype', value: 'subtype' },
        { text: 'Remaining', value: 'remaining' },
        { text: 'Total', value: 'total' },
      ];
    },
  },
  mounted() {
    const eventId = this.$store.state.hackathonID || '';
    if (eventId === '') {
      // TODO the events should be retrieved in App.vue, not Main.vue
      this.$router.push('/');
    }
    this.giveawaysClient = new GiveawaysClient(this.currentJwtToken, eventId);
    this.getGiveawaysData();
  },
  methods: {
    async getGiveawaysData() {
      this.loading = true;
      this.giveaways = [];
      const response = await this.giveawaysClient.getGiveaways();
      this.loading = false;
      /* eslint-disable-next-line no-restricted-syntax */
      for (const giveaway of response) {
        const values = [];
        /* eslint-disable-next-line no-restricted-syntax */
        for (const subtype of giveaway.subtypes) {
          values.push({
            type: giveaway.type,
            subtype: subtype.subtype,
            total: subtype.total,
            remaining: subtype.remaining,
          });
        }
        if (values.length === 0) {
          values.push({
            type: giveaway.type,
            subtype: null,
            total: giveaway.total,
            remaining: giveaway.remaining,
          });
        }
        this.giveaways.push(...values);
      }
    },
    async loadUnredeemedGiveaways() {
      this.loading = true;
      this.closeUnredeemedGiveawaysDialog();

      await this.giveawaysClient.loadUnredeemedGiveaways(this.type, this.subtype);
      await this.getGiveawaysData();
    },
    async addNewGiveaways() {
      this.loading = true;
      this.closeAddGiveawaysDialog();

      await this.giveawaysClient.addGiveaways(this.type, this.subtype, this.codes.split('\n'));
      this.codes = '';
      await this.getGiveawaysData();
    },
    closeAddGiveawaysDialog() {
      this.addNewGiveawaysDialog = false;
    },
    closeUnredeemedGiveawaysDialog() {
      this.loadUnredeemedGiveawaysDialog = false;
    },
  },
};
</script>
